export function formatPendingCount(count: number) {
  if (count > 99) {
    return '99+';
  }

  return String(Math.max(0, count));
}

type PendingCountBadgeProps = {
  count: number;
  tone?: 'pending' | 'complete';
  size?: 'sm' | 'md';
  showWhenZero?: boolean;
  className?: string;
};

export function PendingCountBadge({
  count,
  tone = 'pending',
  size = 'md',
  showWhenZero = false,
  className = '',
}: PendingCountBadgeProps) {
  if (count <= 0 && !(showWhenZero && tone === 'complete')) {
    return null;
  }

  const sizeClass = size === 'sm'
    ? 'min-w-4 h-4 px-0.5 text-[10px] border-[1.5px]'
    : 'min-w-[18px] h-[18px] px-1 text-[11px] border-2';
  const toneClass = tone === 'complete' ? 'bg-primary' : 'bg-danger';

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full border-surface font-extrabold leading-none text-white ${sizeClass} ${toneClass} ${className}`}
    >
      {formatPendingCount(count)}
    </span>
  );
}
